import { BudgetTemplate } from 'interfaces/BudgetTemplate';
import { RepositoryParams, api } from '..';

export type ConsolidatedBudgetFilters = {
  budgetTemplate?: BudgetTemplate;
  budgetTemplateId?: string;
  costCenterId?: string;
  budgetTemplateName?: string;
  month?: string;
  type?: string;
  typeDescription?: string;
  department?: string;
} & RepositoryParams;

export type ConsolidatedEvolutionFilters = {
  budgetTemplateId?: string;
  costCenterId?: string;
  categoryId?: string;
  type?: string;
} & RepositoryParams;

export const list = async (params: ConsolidatedBudgetFilters) => {
  const { q, type, budgetTemplateId, page = 1, size } = params;
  let queryParams = { q, page, size } as any;

  if (type) {
    queryParams = { ...queryParams, type };
  }

  return api.get(`/budget-consolidado/${budgetTemplateId}`, {
    params: queryParams,
  });
};

export const listByCostCenter = async (params: ConsolidatedBudgetFilters) => {
  const { type, budgetTemplateId, costCenterId } = params;
  let queryParams = {};
  if (type) queryParams = { ...queryParams, type };

  return api.get(
    `/budget-consolidado/${budgetTemplateId}/costCenter/${costCenterId}`,
    {
      params: queryParams,
    }
  );
};

export const listByMonthAndCategory = async (
  params: ConsolidatedBudgetFilters & { categoryId: string }
) => {
  const { type, budgetTemplateId, costCenterId, month, categoryId } = params;
  let queryParams = {};
  if (type) {
    queryParams = { ...queryParams, type };
  }
  return api.get(
    `/budget-consolidado/${budgetTemplateId}/costCenter/${costCenterId}/${month}/${categoryId}`,
    {
      params: queryParams,
    }
  );
};

export const listByBudgetTemplateAndType = async (
  params: ConsolidatedBudgetFilters
) => {
  const { type, budgetTemplateId, department } = params;
  const departmentQuery = department ? department : 'Todos';
  return api.get(
    `/budget-consolidado/report/${budgetTemplateId}/${type}?department=${departmentQuery}`
  );
};

export const getEvolution = async (params: ConsolidatedEvolutionFilters) => {
  const { type, costCenterId, categoryId, budgetTemplateId } = params;
  return api.get(
    `/budget-consolidado/${budgetTemplateId}/costCenter/${costCenterId}/evolution/${type}/${categoryId}`
  );
};

export const pin = async (params: {
  budgetTemplateId: string;
  costCenterId: string;
  categoryId: string;
}) => {
  return api.put(
    `/budget-consolidado/${params.budgetTemplateId}/costCenter/${params.costCenterId}/pin/${params.categoryId}`
  );
};

export const unpin = async (params: {
  budgetTemplateId: string;
  costCenterId: string;
  categoryId: string;
}) => {
  return api.delete(
    `/budget-consolidado/${params.budgetTemplateId}/costCenter/${params.costCenterId}/pin/${params.categoryId}`
  );
};
